(ns kyber.styles.form)

(defn- base-text
  [gs]
  {:font-size "12px"
   :font-weight (gs [:font-weight :body-20])
   :font-family (gs [:font-family :open-sans])
   :color (gs [:colors :gray-scale-500])})

(defn- field-feedback-text
  [gs]
  {:position :absolute
   :top (gs [:spacing :p0])
   :margin-top (gs [:spacing :p0])
   :font-size (gs [:font-size :caption-20])
   :font-weight (gs [:font-weight :caption-20])
   :font-family (gs [:font-family :open-sans])})

(defn- field-feedback-text-below
  [gs]
  {:margin-top (gs [:spacing :p4])
   :font-size (gs [:font-size :caption-20])
   :font-weight (gs [:font-weight :caption-20])
   :font-family (gs [:font-family :open-sans])})

(defn- get-field-styles
  [gs]
  (merge {:box-sizing :border-box
          :border-radius (gs [:radius :r3])
          :padding-top (gs [:spacing :p4])
          :padding-bottom (gs [:spacing :p4])
          :padding-left (gs [:spacing :p8])
          :width "100%"
          :background-color (gs [:colors :true-white])
          :height (gs [:spacing :p32])
          :border (str "1px solid " (gs [:colors :gray-scale-300]))
          "-webkit-appearance" :none
          "-webkit-border-radius" (gs [:radius :r3])
          "&::placeholder" {:font-weight (gs [:font-weight :body-10])
                            :color (gs [:colors :gray-scale-400])}
          "&:disabled"
          {:background-color (str (gs [:colors :gray-scale-100]))
           :color (gs [:colors :gray-scale-500])}}
         (base-text gs)))

(defn get-base-button-styles
  [gs]
  {:display :flex
   :justify-content :center
   :appearance :none
   :align-items :center
   :height "34px"
   :font-size "12px"
   :border-radius (gs [:radius :r0])
   :padding [[(gs [:spacing :p8])
              (gs [:spacing :p24])
              (gs [:spacing :p8])
              (gs [:spacing :p24])]]
   :text-transform :capitalize
   :cursor :pointer
   :user-select :none
   :transition "all 100ms linear"
   "& span" {:font-size "12px"
             :line-height 0
             :white-space :nowrap}})

(defn get-primary-button-styles
  [gs]
  (merge (get-base-button-styles gs)
         {:border :none
          :background-color (gs [:colors :primary-lite-600])
          :color (gs [:colors :true-white])
          :border-radius (gs [:radius :r0])
          "&:focus" {:outline (gs [:spacing :p0])
                     :border-image :none}
          "&:active" {:background-color (gs [:colors :primary-lite-400])}
          "&:disabled" {:background-color (gs [:colors :gray-scale-200])}

          (gs [:queries :hover])
          {"&:hover" {:background-color (gs [:colors :primary-lite-700])}}}))

(defn- get-submit-button-styles
  [gs]
  (merge {:font-size (gs [:font-size :body-30])
          :font-weight (gs [:font-weight :body-30])
          :font-family (gs [:font-family :open-sans])
          :line-height "1em"
          :border-radius (gs [:radius :r0])}
         (get-base-button-styles gs)
         (get-primary-button-styles gs)))

(defn base-form-styles
  [gs]
  (let [field-styles (get-field-styles gs)]
    {"input[type=text]" field-styles
     "input[type=date]" field-styles
     "input[type=datetime]" field-styles
     "input[type=email]" field-styles
     "input[type=number]" field-styles
     "input[type=search]" field-styles
     "input[type=time]" field-styles
     "input[type=url]" field-styles
     "input[type=password]" field-styles

     "select"
     (merge field-styles
            {:min-width "50px"})

     "textarea"
     (merge field-styles
            {:resize :vertical
             :overflow :hidden
             :min-height "160px"
             :background-color (gs [:colors :true-white])

             (gs [:queries :mobile-landscape])
             {:min-height "120px"}})

     ".reagent-form-field"
     {:position :relative
      :padding-top (gs [:spacing :p24])
      :margin-bottom (gs [:spacing :p8])}

     ".reagent-form-field-label"
     (merge (base-text gs)
            {:display :inline-block
             :font-weight (gs [:font-weight :title-10])
             :font-size (gs [:font-size :title-10])
             :line-height (gs [:font-height :title-10])
             :cursor :pointer
             :margin-bottom (gs [:spacing :p8])})

     ".checkbox-form-field"
     {:display :flex
      :align-items :center
      "& label" {:order 2
                 :margin (gs [:spacing :p0])
                 :margin-left (gs [:spacing :p12])}}

     ".reagent-form-errors"
     (merge (base-text gs)
            {:color (gs [:colors :error-500])
             :position :absolute
             :top (gs [:spacing :p0])
             :margin-top (gs [:spacing :p0])})

     ".reagent-form-field-error"
     (merge (field-feedback-text gs)
            {:color (gs [:colors :error-500])})

     ".reagent-form-field-hint"
     (merge (field-feedback-text gs)
            {:color (gs [:colors :secondary-one-600])})

     ".reagent-form-field-hint-below"
     (merge (field-feedback-text-below gs)
            {:color (gs [:colors :gray-scale-500])})

     ".reagent-form-field-error-below"
     (merge (field-feedback-text-below gs)
            {:color (gs [:colors :error-500])})

     ".reagent-form-submit-button-container"
     {:position :relative
      :padding [[(gs [:spacing :p20])
                 (gs [:spacing :p0])
                 (gs [:spacing :p0])
                 (gs [:spacing :p0])]]

      "& .reagent-form-errors"
      {:white-space :nowrap}}

     ".reagent-form-submit-button"
     (get-submit-button-styles gs)

     ".reagent-form-submitting-tag-container"
     {:position :relative
      :display :block}

     ".reagent-form-submitting-tag"
     {:position :absolute
      :width "100%"
      :height "100%"
      :top 0
      :left 0}}))
